import React, { useState, useEffect } from "react";

import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import useInvoice from "../../hooks/useInvoice";
import ModalGlobal from "../global/ModalGlobal";
import "./tabcustom.css";
import useJWT from "../../hooks/useJWT";
import MultipleFileInput from "../global/MultipleFileInput";
import useSendInvoiceProof from "../../hooks/useSendInvoiceProof";
import Swal from "sweetalert2";
import "./ProductAvatars.css"; // we'll add small custom CSS here
import useBank from "../../hooks/useBank";
import { useMobile } from "../../hooks/mediaHooks";

const SearchInput = ({ }) => {
  return (
    <div className="search-category d-flex h-48 select-border-end-0 radius-end-0 search-form d-sm-flex d-none mb-24">
      <div className="search-form__wrapper position-relative">
        <button
          type="submit"
          className="w-32 h-32 bg-main-one-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
        >
          <i className="ph ph-magnifying-glass" />
        </button>
        <input
          type="text"
          className="search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44"
          placeholder="Search"
        />
      </div>
    </div>
  );
};

const ListElement = ({ data, raw, onPaymentConfirm, onPackageReceived, onShowPaymentInfo }) => {
  const navigate = useNavigate();
  const isMobile = useMobile();
  const visibleProducts = data.products.slice(0, 2);
  const remainingCount = data.products.length - 2;
  const handleOpenDetailOrder = (dataSingle) => {
    const obj = raw.find((item) => item.id === dataSingle.id);

    // navigate and pass state
    navigate(`/order-detail?id=${dataSingle.id}`, { state: obj });
  };
  const statusColor =
    data.status === 2 || data.status === 3 || data.status === 6
      ? "#299E60"
      : data.status === 1
        ? "#df5454"
        : data.status === 0 || data.status === 4 || data.status === 5
          ? "#ebc856"
          : "#d3eb56";
  return (
    <div className="border border-gray-100 rounded-8 px-20 py-20 mb-10 w-100">
      <div className="d-flex w-100 align-items-start justify-content-between">
        <div className="">
          <h6 className="text-xl fw-bold mb-8">{data.invoiceId}</h6>
          <span className="text-sm text-gray-600 mb-8">{data.date}</span>
        </div>
        <span
          className={`text-sm fw-normal text-capitalize`}
          style={{ color: statusColor }}
        >
          {data.status === 4 ? "To Shipping" : data.status === 5 ? "On Delivery" : data.statusName}
        </span>
      </div>
      <div className="d-block d-lg-flex align-items-center justify-content-between gap-16 mt-16">
        <div className="d-flex align-items-center">
          <div className="d-flex avatar-stack">
            {visibleProducts.map((product, idx) => (
              <img
                key={idx}
                src={product.image}
                alt={product.name}
                className="rounded-circle border border-white avatar-img"
              />
            ))}

            {remainingCount > 0 && (
              <div className="rounded-circle border border-white bg-light d-flex align-items-center justify-content-center avatar-img">
                <span className="small fw-bold">+{remainingCount}</span>
              </div>
            )}
          </div>
        </div>
        <div className="d-block d-lg-flex align-items-center justify-content-end gap-16 mt-16">
          <button
            onClick={() => handleOpenDetailOrder(data)}
            className={`border ${isMobile ? "w-100" : ""} px-20 py-8 mb-8`}
            style={{
              color: "#a3a3a3 !important",
              borderColor: "#a3a3a3 !important",
              borderRadius: "8px",
              fontSize: "0.875rem"
            }}
          >
            View Detail
          </button>
          {data.status === 0 ? (
            <>
              <button onClick={() => onShowPaymentInfo(data)} className={`border ${isMobile ? "w-100" : ""} border-main-one-600 text-main-one-600 px-20 py-8 mb-8`} style={{
                borderRadius: "8px",
                fontSize: "0.875rem"
              }}>
                Show Payment Info
              </button>
              <button onClick={() => onPaymentConfirm(data)} className={`border ${isMobile ? "w-100" : ""} border-main-one-600 text-main-one-600 px-20 py-8 mb-8`} style={{
                borderRadius: "8px",
                fontSize: "0.875rem"
              }}>
                Confirm Payment
              </button>
            </>

          ) : data.status === 5 ? (
            <button onClick={() => onPackageReceived(data)} className={`border ${isMobile ? "w-100" : ""} border-main-one-600 text-main-one-600 px-20 py-8 mb-8`} style={{
                borderRadius: "8px",
                fontSize: "0.875rem"
              }}>
              Confirm Received
            </button>
          ) : null}
        </div>

      </div>

    </div>
  );
};

const TabEnum = [
  {
    id: 4,
    key: 4,
    title: "All",
  },
  {
    id: 0,
    key: 0,
    title: "Pending",
  },
  {
    id: 1,
    key: 1,
    title: "Payment Failed",
  },
  {
    id: 2,
    key: 2,
    title: "Payment Success",
  },
  {
    id: 6,
    key: 6,
    title: "History ",
  },
  // {
  //   id: 4,
  //   key: 4,
  //   title: "Pending",
  // },
];

const dummyInvoice = [
  {
    invoiceId: "INV-001",
    date: "01/01/2024",
    status: "finished",
    products: [
      {
        name: "Taylor Farms Broccoli Florets Vegetables",
        variant: "Variant Name",
        price: 50.0,
        originalPrice: 100.0,
        quantity: 1,
        image: "assets/images/thumbs/product-details-thumb1.png",
      },
      {
        name: "Taylor Farms Broccoli Florets Vegetables",
        variant: "Variant Name",
        price: 50.0,
        originalPrice: 100.0,
        quantity: 1,
        image: "assets/images/thumbs/product-details-thumb1.png",
      },
    ],
    totalPrice: 100.0,
  },
  {
    invoiceId: "INV-002",
    date: "01/01/2024",
    status: "finished",
    products: [
      {
        name: "Taylor Farms Broccoli Florets Vegetables",
        variant: "Variant Name",
        price: 50.0,
        originalPrice: 100.0,
        quantity: 1,
        image: "assets/images/thumbs/product-details-thumb1.png",
      },
    ],
    totalPrice: 100.0,
  },
  {
    invoiceId: "INV-003",
    date: "02/01/2024",
    status: "unpaid",
    products: [
      {
        name: "Green Valley Organic Spinach",
        variant: "500g",
        price: 30.0,
        originalPrice: 50.0,
        quantity: 2,
        image: "assets/images/thumbs/product-details-thumb1.png",
      },
    ],
    totalPrice: 60.0,
  },
  {
    invoiceId: "INV-004",
    date: "03/01/2024",
    status: "packed",
    products: [
      {
        name: "Fresh Farm Carrots",
        variant: "1kg",
        price: 20.0,
        originalPrice: 40.0,
        quantity: 3,
        image: "assets/images/thumbs/product-details-thumb1.png",
      },
    ],
    totalPrice: 60.0,
  },
  {
    invoiceId: "INV-005",
    date: "04/01/2024",
    status: "on delivery",
    products: [
      {
        name: "Sweet Corn Pack",
        variant: "3pcs",
        price: 15.0,
        originalPrice: 25.0,
        quantity: 4,
        image: "assets/images/thumbs/product-details-thumb1.png",
      },
    ],
    totalPrice: 60.0,
  },
  {
    invoiceId: "INV-006",
    date: "05/01/2024",
    status: "cancelled",
    products: [
      {
        name: "Organic Tomatoes",
        variant: "1kg",
        price: 25.0,
        originalPrice: 35.0,
        quantity: 2,
        image: "assets/images/thumbs/product-details-thumb1.png",
      },
    ],
    totalPrice: 50.0,
  },
  {
    invoiceId: "INV-007",
    date: "06/01/2024",
    status: "return",
    products: [
      {
        name: "Potato Sack",
        variant: "5kg",
        price: 40.0,
        originalPrice: 55.0,
        quantity: 1,
        image: "assets/images/thumbs/product-details-thumb1.png",
      },
    ],
    totalPrice: 40.0,
  },
];

const MyOrder = ({ }) => {
  const { user } = useJWT();
  const [key, setKey] = useState("4"); // Default to all

  const { fetchInvoice, data, status, error, resetStatus, updateInvoiceStatus, statusUpdate, errorUpdate } = useInvoice();
  const { sendUploadProof, data: uploadData, status: uploadStatus, error: uploadError } = useSendInvoiceProof();
  const { fetchSingleBank, single } = useBank();

  const [invoiceData, setInvoiceData] = useState([]);
  const [invoiceRawData, setInvoiceRawData] = useState([]);

  const [selectedImage, setSelectedImage] = useState([]);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState('');

  const [show, setShow] = useState(false);
  const [showPaymentInfo, setShowPaymentInfo] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleOpenConfirmPayment = (req) => {
    setSelectedInvoiceId(req.id);
    handleShow();
  }

  const handleOpenConfirmPackage = (req) => {
    //setSelectedInvoiceId(req.id);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#970a02",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes"
    }).then((result) => {
      if (result.isConfirmed) {
        updateInvoiceStatus(req.id, 6);
      }
    });
  }

  const handleOpenPaymentInfo = (req) => {
    //setSelectedInvoiceId(req.id);
    console.log(req);
    fetchSingleBank(req.bankTransferId);
    setShowPaymentInfo(true);
  }

  const handleUploadProof = () => {
    sendUploadProof(selectedInvoiceId, selectedImage[0]?.url);
  }

  const reFetchInvoice = () => {
    fetchInvoice({ userId: user.id, status: key === "4" ? null : key });
  }

  useEffect(() => {
    if (statusUpdate === "done" || statusUpdate === "error") {
      reFetchInvoice();
    }
  }, [statusUpdate]);

  useEffect(() => {
    if (user) {
      //console.log(typeof key, key);
      fetchInvoice({ userId: user.id, status: key === "4" ? null : key });
    }
  }, [key, user]);

  useEffect(() => {
    if (data) {
      // convert data to like dummyInvoice
      const formattedData = data.map((inv) => {
        return {
          id: inv.id,
          invoiceId: inv.invoiceNumber,
          date: moment(new Date(inv.createdDate)).format("DD/MM/YYYY HH:mm A"),
          status: inv.status,
          statusName: inv.statusName,
          shippingCost: inv.shippingCost,
          bankTransferId: inv.bankTransferId,
          products: inv.details.map((item) => ({
            name: item.productName,
            variant: item.variantCombinationName,
            price: item.price,
            originalPrice: item.price,
            quantity: item.qty,
            image:
              item.photoData[0]?.url ||
              "assets/images/thumbs/product-details-thumb1.png",
          })),
          subTotal: inv.price,
          totalPrice: inv.totalPayment,
        };
      });
      setInvoiceRawData(data);
      setInvoiceData(formattedData);
    }
  }, [data]);

  useEffect(() => {
    if (uploadStatus !== "loading") {
      if (uploadStatus === "done") {
        setSelectedImage([]);
        handleClose();
        //fetchInvoice({ userId: user.id, status: key === "5" ? null : key });
        Swal.fire({
          title: "Your Payment Proof has been uploaded!",
          icon: "success",
        });
      } else if (uploadStatus === "error") {
        Swal.fire({
          title: "Error",
          text: uploadError || "Something went wrong during checkout",
          icon: "error",
        });
      }
      reFetchInvoice();
    }

  }, [uploadStatus]);

  return (
    <>
      <section className="checkout p-10">
        <div className="container container-lg">
          <h6 className="text-xl mb-24">My Order</h6>
          <Tabs
            //defaultActiveKey="profile"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            id="fill-tab-example"
            color="#f1f1f1"
            style={{
              borderBottom: "none",
            }}
            fill
          >
            {TabEnum.filter((item) => item.key !== 1 && item.key !== 2).map((item, index) => (
              <Tab eventKey={item.key} title={item.title} key={index}>
                <div className="py-30">
                  <SearchInput />
                  {invoiceData?.map((inv, ind) => (
                    <ListElement key={ind} data={inv} raw={invoiceRawData} onPaymentConfirm={handleOpenConfirmPayment} onPackageReceived={handleOpenConfirmPackage} onShowPaymentInfo={handleOpenPaymentInfo} />
                  ))}
                  {invoiceData && invoiceData.length === 0 && (
                    <div className="cart-action d-flex flex-wrap justify-content-center align-items-center mt-40">
                      <img
                        src="/assets/images/no-data.svg"
                        width={"60%"}
                        alt=""
                      />
                    </div>
                  )}
                </div>
              </Tab>
            ))}
          </Tabs>
        </div>
      </section>
      <ModalGlobal
        show={show}
        size="md"
        onClose={handleClose}
        title="Upload Payment Confirmation"
      >
        <div className="d-flex align-items-center justify-content-center">
          <MultipleFileInput
            files={selectedImage}
            isMultiple={false}
            fieldName={'photos'}
            onUploaded={(file) => setSelectedImage(file)}
            onRemoved={(file) =>
              setSelectedImage([])
            }
          />
        </div>

        <button className="btn border border-main-one-600 text-main-one-600 mt-20 w-100" disabled={selectedImage.length === 0} onClick={handleUploadProof}>
          {selectedImage.length === 0 ? "Upload Payment Confirmation" : "Send Confirmation Payment"}
        </button>
      </ModalGlobal>
      <ModalGlobal
        show={showPaymentInfo}
        size="md"
        onClose={() => setShowPaymentInfo(false)}
        title="Payment Info"
      >
        <div className="d-flex align-items-center justify-content-center">
          <img src={single?.image || ""} alt="" />
        </div>
      </ModalGlobal>
    </>
  );
};

export default MyOrder;
